module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex input-container"
  }, [_c('el-input', _vm._b({
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": _vm.sendValue
    }
  }, 'el-input', _vm.$attrs, false)), _vm._v(" "), _c('img', {
    staticClass: "location",
    attrs: {
      "src": _vm.location,
      "alt": "localizador"
    }
  })], 1), _vm._v(" "), _vm._t("err")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68aa1232","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputComponent.vue
// module id = 1132
// module chunks = 32